import React from "react";

export default function AlertComponentMobile(props) {
  return (
    <div className="alert-container-mobile">
      {props.text.includes("Alerts:") ? (
        <>
          <div className="light-mobile"></div>
          <div className="title-alert-mobile">{props.text}</div>
        </>
      ) : props.text.includes("Allergies:") ? (
        <>
          <div className="light-yellow-mobile"></div>
          <div className="title-alert-yellow-mobile">{props.text}</div>
        </>
      ) : (
        <>
          <div className="light-blue-mobile"></div>
          <div className="title-alert-blue-mobile ">{props.text}</div>
        </>
      )}
    </div>
  );
}
